import "./Button.scss";

export default function Button({text, className, href, newTab, download}) {
  const isLink = !!href;
  const Comp = isLink ? "a" : "button";

  return (
    <div className={className}>
      <Comp
        className="main-button"
        {...(isLink && {href})}
        {...(newTab && {target: "_blank", rel: "noreferrer"})}
        {...(download && {download})}
      >
        {text}
      </Comp>
    </div>
  );
}
